export enum TargetPlatform {
    None = 0,
    Binance = 1,
    Deribit = 2,
    SamsungWallet = 3,
    TrustWallet = 4,
    RevolutX = 5,
}
